import React, { useRef } from 'react';
import { DocumentSubCategory, DocumentUploadCategory, PropertyDocument, SUBCATEGORY_LABELS } from 'types/Documents';
import Button from 'components/Button/Button';
import FileTypeIcon from 'components/Icons/FileTypeIcon';
import ReloadIcon from 'components/Icons/ReloadIcon';
import UploadSvg from 'assets/icons/upload.svg?react';
import { CategoryBadge, DoneBadge } from '../utils';
import { SUPPORTED_FILE_TYPES } from 'utils/documents';
import styles from '../NewOwnerOnboarding.module.css';

interface HistoricalFinancialItemProps {
    category: DocumentUploadCategory | undefined;
    historicalFinancialDocuments: PropertyDocument[];
    uploadDocuments: (e: React.ChangeEvent<HTMLInputElement>, category: DocumentUploadCategory) => Promise<void>;
    disableInteractions: boolean;
}

function HistoricalFinancialItem({
    category: historicalCategory,
    historicalFinancialDocuments,
    uploadDocuments,
    disableInteractions,
}: HistoricalFinancialItemProps): JSX.Element {
    if (!historicalCategory) return <></>;

    const historicalInputRef = useRef<HTMLInputElement>(null);

    const uploadHistoricalFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
        await uploadDocuments(e, historicalCategory);
    };

    return (
        <div
            className={`${styles.item} ${
                historicalFinancialDocuments.length > 0
                    ? styles.done
                    : historicalCategory.is_required
                    ? styles.required
                    : ''
            }`}
        >
            <ReloadIcon className={styles.itemIcon} />
            <div>
                <div className={styles.titleRow}>
                    <span className={styles.itemTitle}>{SUBCATEGORY_LABELS[DocumentSubCategory.REVENUE_REPORT]}</span>
                    <CategoryBadge category={historicalCategory} />
                </div>
                <p className={styles.itemDescription}>Past revenue helps us benchmark and set the right rates.</p>
            </div>
            <div className={styles.actions}>
                {historicalFinancialDocuments.length > 0 && <DoneBadge />}
                <input
                    ref={historicalInputRef}
                    type="file"
                    hidden
                    multiple
                    accept={SUPPORTED_FILE_TYPES}
                    onChange={uploadHistoricalFiles}
                />
                <Button
                    color="info"
                    size="sm"
                    onClick={() => historicalInputRef.current?.click()}
                    className={styles.actionButton}
                    disabled={disableInteractions}
                >
                    <UploadSvg />
                    Upload
                </Button>
            </div>
            {historicalFinancialDocuments.map((file, i) => (
                <div key={i} className={styles.fileItem}>
                    <FileTypeIcon fileType={file.file_type} size={20} />
                    <span className={styles.fileName}>{file.display_name}</span>
                </div>
            ))}
        </div>
    );
}

export default HistoricalFinancialItem;
